import React from 'react';
import { motion } from 'framer-motion';
interface Step {
  number: string;
  title: string;
  description: string;
}
const steps: Step[] = [{
  number: '1',
  title: 'Before You Order Your Stone Countertop',
  description: "Bring your measurements or a simple layout, choose your stone, edge, sink, faucet, and backsplash, and we'll provide a detailed estimate based on your project."
}, {
  number: '2',
  title: 'Ordering & Templating',
  description: 'Approve your quote, place your deposit, and our team will visit your home to take precise measurements and create a template for a perfect fit.'
}, {
  number: '3',
  title: 'Stone Countertop Installation',
  description: 'We custom-fabricate your countertops using advanced equipment, then professionally install them while keeping your home clean and protected.'
}, {
  number: '4',
  title: 'After Installation',
  description: "We'll follow up after installation to ensure you're completely satisfied, and your project is backed by our one-year installation warranty."
}];
export function ProcessSection() {
  return <section className="w-full bg-white" data-id="element-49" data-mp="3lndl4s8eqcdq">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-24" data-id="element-50" data-mp="3gp27e6ezrhq8">
        <h2 className="font-display text-3xl text-brand-charcoal sm:text-4xl" data-id="element-51" data-mp="3co085pl2r5o9">
          Four Simple Steps
        </h2>

        <div className="relative mt-12 grid grid-cols-1 gap-10 md:grid-cols-4 md:gap-6" data-id="element-52" data-mp="d9em1hq52aw0">
          <div className="absolute top-6 left-0 hidden h-px w-full bg-gray-200 md:block" aria-hidden="true" data-id="element-53" data-mp="8a24nci1dw0t" />
          {steps.map((step, index) => <motion.div key={step.number} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="relative" data-id="element-54" data-mp="3vmunp0sd4a5h" data-mpi={index}>
              <div className="relative z-10 flex h-12 w-12 items-center justify-center rounded-full bg-brand-teal font-display text-lg text-white" data-id="element-55" data-mp="2bqoumk6z0jux">
                {step.number}
              </div>
              <h3 className="mt-5 font-display text-xl text-brand-charcoal" data-id="element-56" data-mp="22q0gzqlholik">{step.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-gray-600" data-id="element-57" data-mp="27p3mtd9amvrl">{step.description}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}